import {
    SCHEDULE_MTO_EVENT_LIST,
    SCHEDULE_MTO_EVENT_LIST_SUCCESS,
    SCHEDULE_MTO_EVENT_LIST_ERROR,
    SCHEDULE_MTO_DETAIL_EVENT_LIST,
    SCHEDULE_MTO_DETAIL_EVENT_LIST_SUCCESS,
    SCHEDULE_MTO_DETAIL_EVENT_LIST_ERROR,
    SCHEDULE_MTO_REMINDER,
    SCHEDULE_MTO_REMINDER_SUCCESS,
    SCHEDULE_MTO_REMINDER_ERROR
} from "../../actions";

const INIT_STATE = {
    loading: false,
    eventlist: {
        loading: false,
        data: []
    },
    detaileventlist: {
        loading: false,
        data: []
    },
    reminder: {
        data: [],
        modal: false,
        loading: false,
        message: '',
        url: '',
        type: ''
    },
    error: false,
    search: {
        modal: false,
        init: true,
        data: {

        },
        value: {

        }
    }
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case SCHEDULE_MTO_EVENT_LIST:
            return {
                ...state,
                loading: true,
                eventlist: {
                    ...state.eventlist
                }
            }
        case SCHEDULE_MTO_EVENT_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                eventlist: {
                    ...state.eventlist,
                    ...action.payload
                }
            }
        case SCHEDULE_MTO_EVENT_LIST_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case SCHEDULE_MTO_DETAIL_EVENT_LIST:
            return {
                ...state,
                loading: true,
                detaileventlist: {
                    ...state.detaileventlist
                }
            }
        case SCHEDULE_MTO_DETAIL_EVENT_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                detaileventlist: {
                    ...state.detaileventlist,
                    ...action.payload
                }
            }
        case SCHEDULE_MTO_DETAIL_EVENT_LIST_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case SCHEDULE_MTO_REMINDER:
            return {
                ...state,
                loading: true,
                reminder: {
                    ...state.reminder
                }
            }
        case SCHEDULE_MTO_REMINDER_SUCCESS:
            return {
                ...state,
                loading: false,
                reminder: {
                    ...state.reminder,
                    ...action.payload
                }
            }
        case SCHEDULE_MTO_REMINDER_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }

        default:
            return { ...state };
    }
};